import React from 'react'
import PropTypes from 'prop-types'
import { useModal } from './Modal'
import { Icon } from '../../atoms'

export default function ModalHeader({ children, title }) {
  const modalContext = useModal()
  const { title: contextTitle, hasCloseButton } = modalContext || {}

  if (!modalContext) return null
  return (
    <div className="modal-lite__content-header">
      <h3 className="modal-lite__title">{title || children || contextTitle}</h3>
      {hasCloseButton && (
        <span className="modal-lite__close" data-modal-close>
          <Icon className="icon--large" name="cross" />
        </span>
      )}
    </div>
  )
}

ModalHeader.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string
}

ModalHeader.defaultProps = {}
